import script from "./Variant.vue?vue&type=script&setup=true&lang=js"
export * from "./Variant.vue?vue&type=script&setup=true&lang=js"

import "./Variant.vue?vue&type=style&index=0&id=786a0ebc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-786a0ebc"]])

export default __exports__